import { useState, useEffect } from 'react'
import { ApolloClient } from 'apollo-boost'
import gql from 'graphql-tag'
import { IReport, IReportDefinition, IByCategory } from '../types'

const reportsQuery = gql`
  query reportsDefinitionQuery {
    viewer {
      company {
        reports {
          id
          name
          hidden
          categoryName
          newReport
          description
        }
        product {
          reports
        }
      }
    }
  }
`

interface IProps {
  client: ApolloClient<any>
}

interface IPayload {
  viewer: {
    company: {
      reports: IReport[]
      product: {
        reports: string[]
      }
    }
  }
}

let persistedState: IReportDefinition = {
  categories: [],
  byCategory: {},
  reports: [],
  availableReports: [],
}

let persistedLoading = true

export default function useReportsDefinition({ client }: IProps) {
  const [definition, setReportsInfo] = useState<IReportDefinition>(persistedState)
  const [loading, setLoading] = useState<boolean>(persistedLoading)

  useEffect(() => {
    client.query<IPayload>({ query: reportsQuery }).then(
      ({
        data: {
          viewer: {
            company: {
              reports,
              product: { reports: availableReports },
            },
          },
        },
      }) => {
        const output: IByCategory = {}
        const categories: string[] = ['All']
        reports.forEach((report) => {
          if (!categories.includes(report.categoryName)) {
            categories.push(report.categoryName)
          }
          if (!report.hidden) {
            output['All'] = output['All'] ? [...output['All'], report] : [report]
            output[report.categoryName] = output[report.categoryName]
              ? [...output[report.categoryName], report]
              : [report]
          }
        })
        setLoading(false)
        setReportsInfo({
          categories,
          byCategory: output,
          reports,
          availableReports,
        })
      }
    )
  }, [client])

  useEffect(() => {
    persistedLoading = loading
    persistedState = definition
  })

  return { definition, loading }
}
